// extracted by css-extract-rspack-plugin
export default {"SidesheetContent":"QqTsB","SidesheetCloseButton":"pCCqq","FlexScrollContainer":"aJtdu","OverflowAuto":"CPwLu","InsightsTab":"Ppyeq","TabSibling":"N7Vao"};